import { render, staticRenderFns } from "./ShipmentsListPage.vue?vue&type=template&id=c178b958&scoped=true&"
import script from "./ShipmentsListPage.vue?vue&type=script&lang=ts&"
export * from "./ShipmentsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentsListPage.vue?vue&type=style&index=0&id=c178b958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c178b958",
  null
  
)

export default component.exports